import { ModalManager } from 'react-dynamic-modal';
import { toast } from 'react-toastify';
import { format as fns, addMinutes } from "date-fns";
import auth from './AuthService';
import { useRef, useEffect } from 'react';
import { scheduleTypes, when_Automated } from './constants';
const uuidv4 = require('uuid');

export const EVO = {
    alert(message) {
        alert(message);
    },

    post(url, data, options) {
        options = Object.assign({}, { method: "POST" }, options);
        return this.get(url, data, options);
    },

    put(url, data, options) {
        options = Object.assign({}, { method: "PUT" }, options);
        return this.get(url, data, options);
    },

    get(url, data, options) {
        options = options || {};
        let headers = Object.assign({}, {
            "Accept": "application/json",
            "Content-Type": "application/json; charset=utf-8"
        }, options.headers);

        var authInstance = auth.getInstance();

        var token = authInstance.getAccessToken(options.allowAnon);
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        if (authInstance.isViewingAsClient()) {
            const user = authInstance.getUser();
            headers['x-asclientid'] = user.asClientId;
        }

        options = Object.assign({}, {
            method: "GET",
            removeEmptyProperties: true,
            displayToastOnError: true
        }, options, { headers: headers });

        if (data && options.removeEmptyProperties) {
            data = this.removeEmptyProperties(data);
        }

        options.body = JSON.stringify(data);


        if (options.noContentType) {
            delete options.headers['Content-Type'];
        }

        let rootUrl = '';
        if (process.env.NODE_ENV === 'development') {
            if (window.location.href.indexOf('5001') > -1) {
                rootUrl = 'https://stagingdash.peptalkr.com.au';
            }
        }

        return fetch(rootUrl + url, options).then(response => response.json()).then(r => {
            if (r.error) {
                if (options.displayToastOnError) {
                    EVO.error(r.error);
                    return;
                }
                else {
                    throw new Error(r.error)
                }
            }

            return r;
        });
    },

    fetch(options, data) {
        return EVO.get(options.url, data, options);
    },

    getAndStore(key, url, data, options) {
        options = Object.assign({}, {
            sync: false
        }, options);

        if (!options.sync) {
            var local = this.storage.get(key);
            if (local) {
                return new Promise((resolve) => resolve(local));
            }
        }

        return this.get(url, data, options).then(function (response) {
            EVO.storage.set(key, response);
            return response;
        });
    },

    guid() {
        return uuidv4();
    },

    guidHyphen(n) {
        return n.replace(/([0-9a-f]{8})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{12})/, "$1-$2-$3-$4-$5");
    },

    deCamel(val) {
        return val.charAt(0).toUpperCase() + val.slice(1).replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
    },

    getParamsId(props, idTag = 'id') {
        let id = null;
        if (props && props.match && props.match.params && props.match.params[idTag]) {
            id = props.match.params[idTag];
        }

        return id;
    },

    updateIdFromNew(props, item, url) {
        const id = EVO.getParamsId(props);
        if (item && item.id && id && item.id !== id) {
            props.history.replace(`${url}/${item.id}`);
            props.history.go();
        }
    },

    getSelectItemFromIdName(list) {
        return EVO.getSelectItemFromObject(list, aa => aa.name, aa => aa.id);
    },

    getSelectItemFromIdNameAsString(list) {
        return EVO.getSelectItemFromObject(list, aa => aa.name, aa => aa + '');
    },

    getSelectItemFromSingularArray(list) {
        return EVO.getSelectItemFromObject(list, aa => aa, aa => aa + '');
    },

    getSelectItemFromObjectOfSelectItems(obj) {
        return Object.keys(obj).map(o => obj[o]);
    },

    getSelectItemFromObject(list, funcLabel, funcValue, funcSort) {
        let retval = list.map(aa => { return { value: funcValue(aa), label: funcLabel(aa), sortLabel: funcSort ? funcSort(aa) : funcLabel(aa) }; });
        retval.sort((a, b) => a.sortLabel.localeCompare(b.sortLabel));
        return retval;
    },

    getPropertyNameFromValue(list, value) {
        var result = Object.keys(list).filter(p => list[p] === value);
        return result ? result[0] : null;
    },

    getPropertyNameFromObjectValue(list, value) {
        var result = Object.keys(list).filter(p => list[p].value === value);
        return EVO.any(result) ? list[result[0]].label : null;
    },

    getPropertyNameFromListValue(list, value) {
        var result = list.filter(p => p.value === value);
        return EVO.any(result) ? result[0].label : null;
    },

    firstOrDefault(list, condition) {
        return list.reduce((b, a) => (b === null && condition(a)) ? a : b, null);
    },

    any(list, condition) {
        if (!condition)
            return list && list.length > 0;

        return list && list.length > 0 && list.filter(condition).length > 0;
    },

    clone(obj) {
        if (typeof obj === 'undefined') {
            return undefined;
        }

        return JSON.parse(JSON.stringify(obj));
    },

    getDetailsItemById(items, id, defaultVals) {
        if (id) {
            var item = EVO.firstOrDefault(items, a => a.id === id);
            if (item) {
                if (defaultVals) {
                    item = Object.assign(EVO.clone(defaultVals), item);
                }

                return item;
            }
        }

        return null;
    },

    removeEmptyProperties: function (item) {
        var retVal = {};
        var test = item || this;
        for (var i in test) {
            if (test[i] === null || test[i] === undefined || test[i] === '') {
                // test[i] === undefined is probably not very useful here
                //delete test[i];
            }
            else {
                retVal[i] = test[i];
            }
        }

        return retVal;
    },

    groupBy: function (array, keyFunction) {
        if (!array || array.length === 0)
            return [];

        var groups = {};
        array.forEach(function (el) {
            var key = keyFunction(el);
            if (key in groups === false) {
                groups[key] = [];
            }
            groups[key].push(el);
        });
        return Object.keys(groups).map(function (key) {
            return {
                key: key,
                values: groups[key]
            };
        });
    },

    success: function (message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    },

    error: function (message) {
        toast.error(message, {
            autoClose: 8000
        });
    },

    storage: {
        get(key) {
            var local = localStorage.getItem(key);
            if (local) {
                return JSON.parse(local);
            }

            return null;
        },

        set(key, object) {
            localStorage.setItem(key, JSON.stringify(object));
        },

        remove(key) {
            localStorage.removeItem(key);
        }
    },

    keepAlive() {
        window.setInterval(() => EVO.get('/api/test/keepalive').then(a => console.log(a)), 50000);
    },

    isEmptyObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }

        return true;
    },

    modal: function (contents) {
        ModalManager.open(contents);
    },

    closeModal: function () {
        ModalManager.close();
    },

    canBeZero: function (val) {
        return val || val === 0;
    },

    isNumber: function (val) {
        return typeof val === 'number';
    },

    hasValue: function (obj) {
        return typeof obj !== 'undefined';
    },

    format: function (date, format) {
        return date ? fns(new Date(date), format) : null;
    },

    utcNow: function () {
        return EVO.localToUtc(new Date());
    },

    localToUtc: function (date) {
        const actualDate = new Date(date);
        const offset = actualDate.getTimezoneOffset();
        const utc = addMinutes(actualDate, offset);
        return utc;
    },

    numberDescriptor: function (number) {
        if (isNaN(number)) {
            return '';
        }

        var mod = number % 10;
        if (mod === 1) {
            return number + 'st';
        }
        else if (mod === 2) {
            return number + 'nd';
        }
        else if (mod === 3) {
            return number + 'rd';
        }
        else {
            return number + 'th';
        }
    },

    log() {
        console.log(...arguments);
        return '';
    },

    ploralise(a) {
        if (!a) return a;
        if (a.slice(a.length - 1) === 's') return a + 'es';
        if (a.slice(a.length - 1) === 'y') return a.substr(0, a.length - 1) + 'ies';
        return a + 's';
    },

    dePloralise(a, count) {
        if (a && count === 1 && a.slice(a.length - 1) === 's') {
            return a.substr(0, a.length - 1);
        }

        return a;
    },

    useTraceUpdate(props) {
        const prev = useRef(props);
        useEffect(() => {
            const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
                if (prev.current[k] !== v) {
                    ps[k] = [prev.current[k], v];
                }
                return ps;
            }, {});
            if (Object.keys(changedProps).length > 0) {
                console.log('Changed props:', changedProps);
            }
            prev.current = props;
        });
    },

    choreHasFilters(chore, incDates) {
        var retVal = EVO.any(chore.sexes) ||
            EVO.any(chore.practitioners) ||
            EVO.any(chore.appointmentCategories) ||
            EVO.any(chore.businesses) ||
            EVO.any(chore.billableItems) ||
            EVO.any(chore.products) ||
            EVO.any(chore.medicalAlerts) ||
            EVO.any(chore.cancellationReasons) ||
            (EVO.hasValue(chore.appointmentCount) && EVO.isNumber(chore.appointmentCount) && chore.whenAutomatedId !== when_Automated.OnCount.value) ||
            EVO.any(chore.appointmentTypes) || (incDates && chore.scheduleTypeId === scheduleTypes.OneOff.value && chore.oneOffFrom && chore.oneOffTo);
        return retVal;
    }
};


// WEBPACK FOOTER //
// ./src/EVO.js